export default Object.freeze({
  home: "/",
  bookTicket: "/book-tickets",
  explore: "/explore",
});
